module.exports = __webpack_public_path__ + "static/img/MY@3x.fa397fd0.jpg";